import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=8b603622"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=8b603622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports